import { useEffect, useState } from "react";
import api from "@/lib/api";

const quando = (iso) => new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export default function UltimoBackupRiga() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/gdpr/backup/status").then((r) => setS(r.data)).catch(() => setS({ errore: true })); }, []);
  if (!s) return null;
  const ok = s.last_success?.at;
  const fallitoDopo = s.last_failed?.at && (!ok || s.last_failed.at > ok);
  const vecchio = ok && Date.now() - new Date(ok).getTime() > 26 * 3600 * 1000;
  const verde = ok && !fallitoDopo && !vecchio && s.configured;
  return (
    <div className="card-immo p-4 flex items-center gap-3" data-testid="ultimo-backup-riga">
      <span data-testid="ultimo-backup-bollino" className={`w-3 h-3 rounded-full shrink-0 ${verde ? "bg-emerald-500" : "bg-red-500"}`} title={verde ? "Backup regolare" : "Backup da controllare"} />
      <div className="text-sm">
        <span className="font-semibold">Ultimo backup: </span>
        <span data-testid="ultimo-backup-data">{ok ? quando(ok) : "nessun backup riuscito"}</span>
        {!verde && <div className="text-xs text-red-600">{!s.configured ? "Backup non configurato" : fallitoDopo ? `Ultimo tentativo fallito il ${quando(s.last_failed.at)}` : vecchio ? "Nessun backup nelle ultime 26 ore" : "Da controllare"}</div>}
      </div>
    </div>
  );
}
